import React from 'react';
import Navbar from './Navbar';
import './App.css';

function Info() {
  return (
    <div className="App info-page">
      <Navbar />
      <div className="info-content">
        <div className="info-container">
          <h1>About Album Cards</h1>
          <p>
            Album Cards brings physical music collecting into the digital age. We create custom NFC-enabled cards that artists can sell as physical albums, 
            giving fans something tangible to collect, display, and trade while maintaining the convenience of streaming.
          </p>
          <p>
            When music went digital, we gained convenience but lost the ritual of collecting. No more album art on your shelf, no more lending 
            a CD to a friend, no more browsing record stores. Album Cards brings back what we lost without the hassle of outdated technology.
          </p>
          <h2>How It Works</h2>
          <p>
            Each Album Card contains an NFC chip that, when tapped with a phone, instantly plays the album through our mobile app. 
            No pairing, no downloads, no subscriptions - just tap and play. The physical card features the album artwork and can be 
            collected, displayed, or traded just like vinyl or CDs.
          </p>
          <p>
            Artists upload their music to our platform, and we handle the manufacturing, programming, and fulfillment of the physical cards. 
            Fans purchase cards directly from artists at shows, online, or in stores. Each card provides permanent access to the album 
            for whoever holds it - creating real value in physical ownership again.
          </p>
          <h2>For Artists</h2>
          <p>
            Album Cards offers artists a new revenue stream that combines the benefits of physical and digital distribution. 
            You maintain full ownership of your music while we handle the technical infrastructure and manufacturing. 
            Cards can be sold at any price point you choose, with higher margins than traditional streaming.
          </p>
          <p>
            Our platform provides analytics on card usage, geographic distribution of your fans, and listening patterns. 
            We support limited editions, signed cards, and special releases - giving you creative control over how your music is packaged and sold. 
            Join us in bringing back the album as a physical art form.
          </p>
          <div style={{ marginTop: '60px', paddingTop: '30px', borderTop: '1px solid #e0e0e0', textAlign: 'center' }}>
            <a href="/terms" style={{ color: '#666', textDecoration: 'none', fontSize: '14px' }}>Terms of Service</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Info;